"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 4v7h20V4zm8 16h12v-7H10zm-8 0h6v-7H2z"
}), 'ViewComfySharp');